// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* //////////////////   FONT /////////////////// */

/* ///////////////// CAROUSEL /////////////////// */

.carousel-status{
  display: none;
}
.carousel .slide .test{
  object-fit: cover;
  height: 350px;
}
.container-slide-img{
  overflow: hidden;
  height: 350px;
}
.carousel .thumbs{
  padding: 0 0 0 10px;
  .test{
    height: 80px;
    min-height: 80px;
    object-fit: cover;
  }
}



.react-datepicker-wrapper {
    display: inline-block;
    padding: 0;
    border: 0;
    width: 100%;
}

/* /////////// COMMUN ///////////////// */

.displaynone{
  display: none;
}
.container{
  padding: 0 1em;
  margin: auto;
  text-align: center;
}

input{
  height: 2.7em;
  width: 97.5%;
}
select{
  height: 3em;
  width: 100%;
}
label{
  margin: 5px 0;
}

/* ///////////// HEADER //////////////////////*/
header {
  display: flex;
  justify-content: space-around; 
  align-items: center;
  width: 100%;
  height: 6em;
  background-color: #06254b
}
.logo {
  width: 6em
}
.logoK{
  width: 2em;
}
.NavLink {
  padding: 1em;
  color: white;
  font-weight: bold;
  text-decoration: none;
  transition: background-color 0.3s;
}
.NavLink:hover{
  background-color: #42bbee;
  transition: 0.8s;
}



/*  ///////////// BURGER MENU /////////////////// */
.burger-menu {
  position: relative;
}

.burger-button {
  background: #06254b;
  border: none;
  font-size: 3em;
  cursor: pointer;
  color: #ffffff;
}

.menu-items {
    position: absolute;
    top: 40px;
    right: 0;
    background: white;
    background-color: rgb(234 220 205);
    padding: 10px;
    display: flex;
    z-index: 10;
    flex-direction: column;
    width: 16em;
    height: 30em;
    text-align: center;
    justify-content: space-around;
}

.menu-items a {
  text-decoration: none;
  color: #333;
  margin: 0px;
  padding: 20px;
  border: 1px solid #000000;
}

.menu-items a:hover{
  background-color: #42bbee;
  transition: 0.8s;
}
.nav2{
  display: none;
}

/* ///////////////////    ACCUEIL  ////////////////// */

.article-video {
  display: flex;
  justify-content: center; 
}
.container-home {
  padding: 1em 2em;
  text-align: center;
}


/* ////////////// NOS PÂTISSERIES /////////////////// */
.container-nos-patisseries{
  padding: 0 1em;
  text-align: center;
}
.card{
  display: flex;
  margin: 30px 0;
}
.container-img{
  margin: 0;
  position: relative;
}
.container-img figcaption{
  position: absolute;
  top: 0;
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 100%;
}
.card-img{
  width: 100%; 
  height: 100%;
}
.position{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.name{
  background-color: #06254b;
  color: white;
  border-radius: 2em;
  padding: 0 1em;
  margin-left: 1em;
}
.label{
  background-color: #ffffff;
  border-radius: 2em;
  color: black;
  padding: 2px 20px;
  position: absolute;
  right: 0;
  bottom: 0;
  margin-right: 1em;
}


/* ///////////////////// DETAILS /////////////////////// */

.container-details{
  padding: 0 1em;
  margin: auto;
  text-align: center;
}
.title-name{
  font-family: Arial, Helvetica, sans-serif;
  margin: 0.5em ;
}
.category {
  display: inline;
  font-family: Arial, Helvetica, sans-serif;
  margin: 0.5em ;
  background-color: #7ed2f3;
  padding: 0.25em 0.5em; 
  border-radius: 2em;
  font-weight: bold;
}
.description{
  font-family: Arial, Helvetica, sans-serif;
  text-align: justify;
  font-size: 16px;
}
.bg-color{
  margin: 0 0em;
}
.select{
  border-radius: 1em;
  height: 4em;
  width: 12em;
  text-align: center;
}
.price{
  font-size: 2em;
  margin: 0;
}



/* ///////////////// QUI SUIS - JE ////////// */

.img-radius{
  border-radius: 3em;
  width: 60%;
}
.img-min{
  width: 100%;
} 
.title{
  font-family: Arial, Helvetica, sans-serif;
}
.liens{
  display: flex;
  justify-content: space-evenly;
}
.logo-redirect{
  width: 4em;
  padding: 1em;
}
.container-aboutme {
  padding: 1em 2em;
  text-align: center;
}

/* ///////////// DEVIS ////////////////// */

.formulaire-devis{
  padding: 2em;
  margin: 2em;
  background-color: rgb(242 198 150 / 36%);
}
.section-devis{
  display: flex;
  flex-direction: column;
}
.section-flex{
display: flex;
align-items: center;
}
.lien-googlemap{
  text-decoration: none;
  color: #000000;
}
.bold{
  font-weight: bold;
}
.retrait{
  height: 2em;
  width: 2em;
}
.livraison{
  height: 2em;
  width: 4.55em;
}
.datepicker{
  width: 95.7%
}
.time{
  width: 98.3% 
}
.btn{
  width: 13em;
  height: 3em;
  margin-top: 1em;
  font-size: 1.2em;
  border-radius: 1em;
  border: none;
  background-color: #579ff7b1;
}
.btn-pastry {
  margin-top: -1em;
  background-color: #06254b;
  color: #ffffff;
}
.btn-devis{
  background-color: #06254b;
  color: #ffffff;
}
.btn-submit{
  background-color: #06254b;
  color: #ffffff;
}



/* ////////////// CONNEXION //////////////////// */

.form-connexion{
  display: flex;
  flex-direction: column;
  padding: 2em;
  margin: 2em;
  background-color: rgb(242 198 150 / 36%);
}

/* ////////// CHARTES DE QUALITÉ ////////////////// */

.article-philo{
  font-family: Arial, Helvetica, sans-serif;
  display: flex;
  flex-direction: column;
  margin: 0 2em;
  text-align: justify;
}
.container-charte {
  display: flex;
  flex-direction: column;
  margin: 0 2em;
}
.article-charte {
  background-color: rgb(242 198 150 / 36%);
  border: 1px solid black;
  padding: 10px;
  display: inline-block;
  text-align: justify;
}
.flex{
  display: flex;
  align-items: flex-start;
  margin: 0 2em;
}
.p{
  margin: 0.7em 0;
}

/* //////////////////  FOOTER  //////////////////// */

.footer {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  background-color: #06254b;
  color: white
}
h4{
  text-align: center;
}
.lien-footer {
  display: flex;
  flex-direction: row;
  justify-content: space-around;}
.logo-lien{
  width: 3em;
  padding: 1em;
}
.div-lien-footer{
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.NavLink-footer {
  text-decoration: none;
  color: white;
  font-weight: bold;
  padding: 1em;
}

/* //////////////////////// USER/DEVIS ////////////////////////////// */

.container-user{
  padding: 0 2em;
  margin: auto;
}
.order-item{
  margin: 20px 0;
  padding: 20px;
  background-color: #f4eeee;
  display: flex;
  flex-direction:row;
  justify-content: space-evenly;
}


/* ///////////////////// BACK OFFICE //////////////// */


.img-admin, .img-user{
  width: 100px;
}
.table-container {
  max-width: 100%; 
  overflow-x: auto; 
  padding: 0 20px; 
  margin: 0 auto; 
}
.table-border {
  border-collapse: collapse; 
}

.table-border th,
.table-border td {
  border: 2px solid black; 
  padding: 8px; 
  text-align: center; 
}

.table-border tr {
  border-bottom: 2px solid black;
}

.devis-article {
  border: 2px solid black;
  margin: 20px 0;
  padding: 20px;
}

.devis-details p {
  margin: 5px 0; 
}

/* Style pour le formulaire */
.form-cake {
  border: 2px solid black;
  padding: 20px;
  margin: 20px;
}

/* Style pour chaque champ du formulaire */
.form-cake input[type="text"],
.form-cake textarea,
.form-cake input[type="checkbox"] {
  border: 2px solid black;
  padding: 5px;
  margin: 10px 0;
  width: 100%;
}

/* Style pour le bouton */
.form-cake button {
  border: 2px solid black;
  background-color: white; 
  color: black; 
  padding: 5px 10px;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
}

.form-cake button:hover {
  background-color: black; 
  color: white; 
}

/* ///////////////////// CHATBOT /////////////////////// */

.chatbot-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9999;
}

.chatbot-toggle {
  background: #06254b;
  color: #ffffff;
  border: none;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  font-size: 28px;
  cursor: pointer;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}

.chatbot-box {
  width: 320px;
  height: 420px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: absolute;
  bottom: 70px;
  right: 0;
}

.chatbot-messages {
  flex: 1 1;
  padding: 10px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.chatbot-msg {
  padding: 10px;
  border-radius: 10px;
  max-width: 80%;
  font-size: 14px;
  line-height: 1.4;
  word-break: break-word;
}

.chatbot-msg.user {
  align-self: flex-end;
  background-color: #f0f0f0;
}

.chatbot-msg.bot {
  align-self: flex-start;
  background-color: #e6f0ff;
}

.chatbot-input {
  display: flex;
  border-top: 1px solid #ccc;
}

.chatbot-input input {
  flex: 1 1;
  border: none;
  padding: 12px;
  font-size: 14px;
  outline: none;
}

.chatbot-input button {
  background-color: #06254b;
  color: white;
  border: none;
  padding: 0 16px;
  cursor: pointer;
}


@media screen and (min-width: 1000px) {
  /* Styles spécifiques pour les écrans de bureau */

  /* //////////// CAROUSEL //////////////// */
  .carousel .slide .test{
    height: 500px;
    width: 100%;
    object-fit: cover;
  }
  .container-slide-img{
    height: 500px;
  }
  .home{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
.custom-carousel-wrapper{
  width: 50%;
}

  /* ////////////// COMMUN /////////////////// */

  .container {
    padding: 2em 4em;
    text-align: center;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

/* ///////////////// MENU BURGER ///////////////*/

.burger-button{
  display: none;
  color: #e8ecee;
}
.nav2{
  display:inline-block;
}

.menu-items a{
  color: #e8ecee;
  border: none;
  font-size: 1.3em;
} 
.NavLink{
  padding: 2em;
}

.article-video {
  padding-bottom: 2em;
}


/* //// NOS PATISSERIES ////// */

.container-nos-patisseries {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(30em, 1fr));
  grid-gap: 1em; 
  margin: 2em ;
  height: 100%;
}
.card {
  max-width: auto; 
  margin:  0;
  padding: 0;
  display: block;
  height: 100%;
}
.box-img{
  height: 100%;
}
.container-img{
  height: 100%;
}



/* ///////////////////// DETAILS /////////////////////// */

.container-details {
  padding:  1em;
}
.dp-fx{
  display: flex;
  flex-direction: row;
  margin: 1em;
}
.details-patisserie{
  width: 50%;
  margin-left: 1em;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}
.category{
  margin: 0 6em;
}
.wrapper{
  padding: 0 10rem;
}




/* /////////////// QUI SUIS JE ? /////////////////// */

.img-radius{
  border-radius: 4em;
  width: 20%;
}
.img-min {
  display: block; /* Empêche l'image d'être inline */
  max-width: 100%; /* Assure que l'image ne dépasse pas le conteneur */
  width: 300px; /* Taille par défaut de l'image pour les écrans de bureau */
  margin: 0 auto; /* Centre l'image horizontalement */
}
.article{
  line-height: 2em;
  font-size: 1.8em;
}
.container-aboutme{
  padding: 0em 20em;
}
.container-home {
  padding: 0em 8em;
}
.logo-lien{
  padding-left: 1em;
}

/* ///////////////////// DEVIS /////////////////// */

.formulaire-devis ,.form-connexion {
  padding: 2em 8em
}
.datepicker {
  width: 97.4%
}
.livraison {
  height: 2em;
  width: 2em;
}
.time {
  width: 99.5%!important
}
.formflex{
display: flex;
gap: 2rem;
}
.formfieldflex{
display: flex;
flex-direction: column;
width: 100%;
}
.chatbot-box {
  width: 90vw;
  height: 400px;
  right: 5vw;
}

}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA,kDAAkD;;AAElD,mDAAmD;;AAEnD;EACE,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,mBAAmB;EACnB;IACE,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;;;AAIA;IACI,qBAAqB;IACrB,UAAU;IACV,SAAS;IACT,WAAW;AACf;;AAEA,yCAAyC;;AAEzC;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,WAAW;EACX,WAAW;AACb;AACA;EACE,aAAa;AACf;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX;AACF;AACA;EACE;AACF;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,iCAAiC;AACnC;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;;;AAIA,mDAAmD;AACnD;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,iBAAiB;IACjB,kCAAkC;IAClC,aAAa;IACb,aAAa;IACb,WAAW;IACX,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;;AAEA,uDAAuD;;AAEvD;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;;AAGA,uDAAuD;AACvD;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,iBAAiB;AACnB;;;AAGA,0DAA0D;;AAE1D;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,yCAAyC;EACzC,cAAc;AAChB;AACA;EACE,eAAe;EACf,yCAAyC;EACzC,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,SAAS;AACX;;;;AAIA,+CAA+C;;AAE/C;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,2CAA2C;;AAE3C;EACE,YAAY;EACZ,WAAW;EACX,wCAAwC;AAC1C;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;AACA,aAAa;AACb,mBAAmB;AACnB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE;AACF;AACA;EACE;AACF;AACA;EACE,WAAW;EACX,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;;;;AAIA,kDAAkD;;AAElD;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,wCAAwC;AAC1C;;AAEA,qDAAqD;;AAErD;EACE,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,wCAAwC;EACxC,uBAAuB;EACvB,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,eAAe;AACjB;;AAEA,qDAAqD;;AAErD;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B,CAAC;AAChC;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;;AAEA,uEAAuE;;AAEvE;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,6BAA6B;AAC/B;;;AAGA,uDAAuD;;;AAGvD;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,6BAA6B;AAC7B;EACE,uBAAuB;EACvB,aAAa;EACb,YAAY;AACd;;AAEA,0CAA0C;AAC1C;;;EAGE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA,0DAA0D;;AAE1D;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,eAAe;EACf,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;;AAGA;EACE,iDAAiD;;EAEjD,2CAA2C;EAC3C;IACE,aAAa;IACb,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;AACF;EACE,UAAU;AACZ;;EAEE,8CAA8C;;EAE9C;IACE,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA,iDAAiD;;AAEjD;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;;AAGA,gCAAgC;;AAEhC;EACE,aAAa;EACb,2DAA2D;EAC3D,aAAa;EACb,YAAY;EACZ,YAAY;AACd;AACA;EACE,eAAe;EACf,UAAU;EACV,UAAU;EACV,cAAc;EACd,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;;;;AAIA,0DAA0D;;AAE1D;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;;;;;AAKA,sDAAsD;;AAEtD;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,cAAc,EAAE,kCAAkC;EAClD,eAAe,EAAE,mDAAmD;EACpE,YAAY,EAAE,2DAA2D;EACzE,cAAc,EAAE,mCAAmC;AACrD;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;;AAEA,oDAAoD;;AAEpD;EACE;AACF;AACA;EACE;AACF;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE;AACF;AACA;AACA,aAAa;AACb,SAAS;AACT;AACA;AACA,aAAa;AACb,sBAAsB;AACtB,WAAW;AACX;AACA;EACE,WAAW;EACX,aAAa;EACb,UAAU;AACZ;;AAEA","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* //////////////////   FONT /////////////////// */\n\n/* ///////////////// CAROUSEL /////////////////// */\n\n.carousel-status{\n  display: none;\n}\n.carousel .slide .test{\n  object-fit: cover;\n  height: 350px;\n}\n.container-slide-img{\n  overflow: hidden;\n  height: 350px;\n}\n.carousel .thumbs{\n  padding: 0 0 0 10px;\n  .test{\n    height: 80px;\n    min-height: 80px;\n    object-fit: cover;\n  }\n}\n\n\n\n.react-datepicker-wrapper {\n    display: inline-block;\n    padding: 0;\n    border: 0;\n    width: 100%;\n}\n\n/* /////////// COMMUN ///////////////// */\n\n.displaynone{\n  display: none;\n}\n.container{\n  padding: 0 1em;\n  margin: auto;\n  text-align: center;\n}\n\ninput{\n  height: 2.7em;\n  width: 97.5%;\n}\nselect{\n  height: 3em;\n  width: 100%;\n}\nlabel{\n  margin: 5px 0;\n}\n\n/* ///////////// HEADER //////////////////////*/\nheader {\n  display: flex;\n  justify-content: space-around; \n  align-items: center;\n  width: 100%;\n  height: 6em;\n  background-color: #06254b\n}\n.logo {\n  width: 6em\n}\n.logoK{\n  width: 2em;\n}\n.NavLink {\n  padding: 1em;\n  color: white;\n  font-weight: bold;\n  text-decoration: none;\n  transition: background-color 0.3s;\n}\n.NavLink:hover{\n  background-color: #42bbee;\n  transition: 0.8s;\n}\n\n\n\n/*  ///////////// BURGER MENU /////////////////// */\n.burger-menu {\n  position: relative;\n}\n\n.burger-button {\n  background: #06254b;\n  border: none;\n  font-size: 3em;\n  cursor: pointer;\n  color: #ffffff;\n}\n\n.menu-items {\n    position: absolute;\n    top: 40px;\n    right: 0;\n    background: white;\n    background-color: rgb(234 220 205);\n    padding: 10px;\n    display: flex;\n    z-index: 10;\n    flex-direction: column;\n    width: 16em;\n    height: 30em;\n    text-align: center;\n    justify-content: space-around;\n}\n\n.menu-items a {\n  text-decoration: none;\n  color: #333;\n  margin: 0px;\n  padding: 20px;\n  border: 1px solid #000000;\n}\n\n.menu-items a:hover{\n  background-color: #42bbee;\n  transition: 0.8s;\n}\n.nav2{\n  display: none;\n}\n\n/* ///////////////////    ACCUEIL  ////////////////// */\n\n.article-video {\n  display: flex;\n  justify-content: center; \n}\n.container-home {\n  padding: 1em 2em;\n  text-align: center;\n}\n\n\n/* ////////////// NOS PÂTISSERIES /////////////////// */\n.container-nos-patisseries{\n  padding: 0 1em;\n  text-align: center;\n}\n.card{\n  display: flex;\n  margin: 30px 0;\n}\n.container-img{\n  margin: 0;\n  position: relative;\n}\n.container-img figcaption{\n  position: absolute;\n  top: 0;\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  height: 100%;\n}\n.card-img{\n  width: 100%; \n  height: 100%;\n}\n.position{\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.name{\n  background-color: #06254b;\n  color: white;\n  border-radius: 2em;\n  padding: 0 1em;\n  margin-left: 1em;\n}\n.label{\n  background-color: #ffffff;\n  border-radius: 2em;\n  color: black;\n  padding: 2px 20px;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  margin-right: 1em;\n}\n\n\n/* ///////////////////// DETAILS /////////////////////// */\n\n.container-details{\n  padding: 0 1em;\n  margin: auto;\n  text-align: center;\n}\n.title-name{\n  font-family: Arial, Helvetica, sans-serif;\n  margin: 0.5em ;\n}\n.category {\n  display: inline;\n  font-family: Arial, Helvetica, sans-serif;\n  margin: 0.5em ;\n  background-color: #7ed2f3;\n  padding: 0.25em 0.5em; \n  border-radius: 2em;\n  font-weight: bold;\n}\n.description{\n  font-family: Arial, Helvetica, sans-serif;\n  text-align: justify;\n  font-size: 16px;\n}\n.bg-color{\n  margin: 0 0em;\n}\n.select{\n  border-radius: 1em;\n  height: 4em;\n  width: 12em;\n  text-align: center;\n}\n.price{\n  font-size: 2em;\n  margin: 0;\n}\n\n\n\n/* ///////////////// QUI SUIS - JE ////////// */\n\n.img-radius{\n  border-radius: 3em;\n  width: 60%;\n}\n.img-min{\n  width: 100%;\n} \n.title{\n  font-family: Arial, Helvetica, sans-serif;\n}\n.liens{\n  display: flex;\n  justify-content: space-evenly;\n}\n.logo-redirect{\n  width: 4em;\n  padding: 1em;\n}\n.container-aboutme {\n  padding: 1em 2em;\n  text-align: center;\n}\n\n/* ///////////// DEVIS ////////////////// */\n\n.formulaire-devis{\n  padding: 2em;\n  margin: 2em;\n  background-color: rgb(242 198 150 / 36%);\n}\n.section-devis{\n  display: flex;\n  flex-direction: column;\n}\n.section-flex{\ndisplay: flex;\nalign-items: center;\n}\n.lien-googlemap{\n  text-decoration: none;\n  color: #000000;\n}\n.bold{\n  font-weight: bold;\n}\n.retrait{\n  height: 2em;\n  width: 2em;\n}\n.livraison{\n  height: 2em;\n  width: 4.55em;\n}\n.datepicker{\n  width: 95.7%\n}\n.time{\n  width: 98.3% \n}\n.btn{\n  width: 13em;\n  height: 3em;\n  margin-top: 1em;\n  font-size: 1.2em;\n  border-radius: 1em;\n  border: none;\n  background-color: #579ff7b1;\n}\n.btn-pastry {\n  margin-top: -1em;\n  background-color: #06254b;\n  color: #ffffff;\n}\n.btn-devis{\n  background-color: #06254b;\n  color: #ffffff;\n}\n.btn-submit{\n  background-color: #06254b;\n  color: #ffffff;\n}\n\n\n\n/* ////////////// CONNEXION //////////////////// */\n\n.form-connexion{\n  display: flex;\n  flex-direction: column;\n  padding: 2em;\n  margin: 2em;\n  background-color: rgb(242 198 150 / 36%);\n}\n\n/* ////////// CHARTES DE QUALITÉ ////////////////// */\n\n.article-philo{\n  font-family: Arial, Helvetica, sans-serif;\n  display: flex;\n  flex-direction: column;\n  margin: 0 2em;\n  text-align: justify;\n}\n.container-charte {\n  display: flex;\n  flex-direction: column;\n  margin: 0 2em;\n}\n.article-charte {\n  background-color: rgb(242 198 150 / 36%);\n  border: 1px solid black;\n  padding: 10px;\n  display: inline-block;\n  text-align: justify;\n}\n.flex{\n  display: flex;\n  align-items: flex-start;\n  margin: 0 2em;\n}\n.p{\n  margin: 0.7em 0;\n}\n\n/* //////////////////  FOOTER  //////////////////// */\n\n.footer {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: auto;\n  background-color: #06254b;\n  color: white\n}\nh4{\n  text-align: center;\n}\n.lien-footer {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;}\n.logo-lien{\n  width: 3em;\n  padding: 1em;\n}\n.div-lien-footer{\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n}\n.NavLink-footer {\n  text-decoration: none;\n  color: white;\n  font-weight: bold;\n  padding: 1em;\n}\n\n/* //////////////////////// USER/DEVIS ////////////////////////////// */\n\n.container-user{\n  padding: 0 2em;\n  margin: auto;\n}\n.order-item{\n  margin: 20px 0;\n  padding: 20px;\n  background-color: #f4eeee;\n  display: flex;\n  flex-direction:row;\n  justify-content: space-evenly;\n}\n\n\n/* ///////////////////// BACK OFFICE //////////////// */\n\n\n.img-admin, .img-user{\n  width: 100px;\n}\n.table-container {\n  max-width: 100%; \n  overflow-x: auto; \n  padding: 0 20px; \n  margin: 0 auto; \n}\n.table-border {\n  border-collapse: collapse; \n}\n\n.table-border th,\n.table-border td {\n  border: 2px solid black; \n  padding: 8px; \n  text-align: center; \n}\n\n.table-border tr {\n  border-bottom: 2px solid black;\n}\n\n.devis-article {\n  border: 2px solid black;\n  margin: 20px 0;\n  padding: 20px;\n}\n\n.devis-details p {\n  margin: 5px 0; \n}\n\n/* Style pour le formulaire */\n.form-cake {\n  border: 2px solid black;\n  padding: 20px;\n  margin: 20px;\n}\n\n/* Style pour chaque champ du formulaire */\n.form-cake input[type=\"text\"],\n.form-cake textarea,\n.form-cake input[type=\"checkbox\"] {\n  border: 2px solid black;\n  padding: 5px;\n  margin: 10px 0;\n  width: 100%;\n}\n\n/* Style pour le bouton */\n.form-cake button {\n  border: 2px solid black;\n  background-color: white; \n  color: black; \n  padding: 5px 10px;\n  cursor: pointer;\n  transition: background-color 0.3s, color 0.3s;\n}\n\n.form-cake button:hover {\n  background-color: black; \n  color: white; \n}\n\n/* ///////////////////// CHATBOT /////////////////////// */\n\n.chatbot-container {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  z-index: 9999;\n}\n\n.chatbot-toggle {\n  background: #06254b;\n  color: #ffffff;\n  border: none;\n  border-radius: 50%;\n  width: 60px;\n  height: 60px;\n  font-size: 28px;\n  cursor: pointer;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n}\n\n.chatbot-box {\n  width: 320px;\n  height: 420px;\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 0 15px rgba(0, 0, 0, 0.25);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  position: absolute;\n  bottom: 70px;\n  right: 0;\n}\n\n.chatbot-messages {\n  flex: 1;\n  padding: 10px;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.chatbot-msg {\n  padding: 10px;\n  border-radius: 10px;\n  max-width: 80%;\n  font-size: 14px;\n  line-height: 1.4;\n  word-break: break-word;\n}\n\n.chatbot-msg.user {\n  align-self: flex-end;\n  background-color: #f0f0f0;\n}\n\n.chatbot-msg.bot {\n  align-self: flex-start;\n  background-color: #e6f0ff;\n}\n\n.chatbot-input {\n  display: flex;\n  border-top: 1px solid #ccc;\n}\n\n.chatbot-input input {\n  flex: 1;\n  border: none;\n  padding: 12px;\n  font-size: 14px;\n  outline: none;\n}\n\n.chatbot-input button {\n  background-color: #06254b;\n  color: white;\n  border: none;\n  padding: 0 16px;\n  cursor: pointer;\n}\n\n\n@media screen and (min-width: 1000px) {\n  /* Styles spécifiques pour les écrans de bureau */\n\n  /* //////////// CAROUSEL //////////////// */\n  .carousel .slide .test{\n    height: 500px;\n    width: 100%;\n    object-fit: cover;\n  }\n  .container-slide-img{\n    height: 500px;\n  }\n  .home{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n.custom-carousel-wrapper{\n  width: 50%;\n}\n\n  /* ////////////// COMMUN /////////////////// */\n\n  .container {\n    padding: 2em 4em;\n    text-align: center;\n    margin: 0 auto;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n}\n\n/* ///////////////// MENU BURGER ///////////////*/\n\n.burger-button{\n  display: none;\n  color: #e8ecee;\n}\n.nav2{\n  display:inline-block;\n}\n\n.menu-items a{\n  color: #e8ecee;\n  border: none;\n  font-size: 1.3em;\n} \n.NavLink{\n  padding: 2em;\n}\n\n.article-video {\n  padding-bottom: 2em;\n}\n\n\n/* //// NOS PATISSERIES ////// */\n\n.container-nos-patisseries {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(30em, 1fr));\n  grid-gap: 1em; \n  margin: 2em ;\n  height: 100%;\n}\n.card {\n  max-width: auto; \n  margin:  0;\n  padding: 0;\n  display: block;\n  height: 100%;\n}\n.box-img{\n  height: 100%;\n}\n.container-img{\n  height: 100%;\n}\n\n\n\n/* ///////////////////// DETAILS /////////////////////// */\n\n.container-details {\n  padding:  1em;\n}\n.dp-fx{\n  display: flex;\n  flex-direction: row;\n  margin: 1em;\n}\n.details-patisserie{\n  width: 50%;\n  margin-left: 1em;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n}\n.category{\n  margin: 0 6em;\n}\n.wrapper{\n  padding: 0 10rem;\n}\n\n\n\n\n/* /////////////// QUI SUIS JE ? /////////////////// */\n\n.img-radius{\n  border-radius: 4em;\n  width: 20%;\n}\n.img-min {\n  display: block; /* Empêche l'image d'être inline */\n  max-width: 100%; /* Assure que l'image ne dépasse pas le conteneur */\n  width: 300px; /* Taille par défaut de l'image pour les écrans de bureau */\n  margin: 0 auto; /* Centre l'image horizontalement */\n}\n.article{\n  line-height: 2em;\n  font-size: 1.8em;\n}\n.container-aboutme{\n  padding: 0em 20em;\n}\n.container-home {\n  padding: 0em 8em;\n}\n.logo-lien{\n  padding-left: 1em;\n}\n\n/* ///////////////////// DEVIS /////////////////// */\n\n.formulaire-devis ,.form-connexion {\n  padding: 2em 8em\n}\n.datepicker {\n  width: 97.4%\n}\n.livraison {\n  height: 2em;\n  width: 2em;\n}\n.time {\n  width: 99.5%!important\n}\n.formflex{\ndisplay: flex;\ngap: 2rem;\n}\n.formfieldflex{\ndisplay: flex;\nflex-direction: column;\nwidth: 100%;\n}\n.chatbot-box {\n  width: 90vw;\n  height: 400px;\n  right: 5vw;\n}\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
